/** Anonymous public-region endpoints — no auth, only published showcase regions. */

const base = '/api/diwa'

export interface PublicRegionCard {
  slug: string
  name: string
  description: string
  type: string
  entity_types: string[]
}

export interface PublicStar {
  id: string
  name: string
  type: string
}

export interface PublicRegion {
  slug: string
  name: string
  description: string
  entity_types: string[]
  entities: PublicStar[]
  relations: { from: string; to: string; type: string }[]
}

export async function listPublicRegions(): Promise<PublicRegionCard[]> {
  const r = await fetch(`${base}/public/regions`)
  if (!r.ok) throw new Error(`public regions: ${r.status}`)
  return (await r.json()).regions
}

export async function publicRegionSet(slugs: string[]): Promise<PublicRegion[]> {
  const q = encodeURIComponent(slugs.join(','))
  const r = await fetch(`${base}/public/regions/constellation?slugs=${q}`)
  if (!r.ok) throw new Error(`public set: ${r.status}`)
  return (await r.json()).regions
}
